/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable class-methods-use-this */
import { Span } from '@opentelemetry/api';
import { SpanProcessor } from '@opentelemetry/sdk-trace-base';

/**
 * A {@link SpanProcessor} that adds browser specific attributes to each span
 * that might change over the course of a session.
 * Static attributes (e.g. User Agent) are added to the Resource.
 */
export class CustomAttributesSpanProcessor implements SpanProcessor {
  procoreObservabilityKeep: boolean;
  constructor(procoreObservabilityKeep: boolean) {
    this.procoreObservabilityKeep = procoreObservabilityKeep;
  }

  onStart(span: Span) {
    span.setAttributes({
      'procore.app.name': 'construction-network-front-end',
    });
    if (this.procoreObservabilityKeep) {
      span.setAttributes({
        'procore.observability.keep': true,
      });
    }
  }

  /* istanbul ignore next */
  onEnd() {}

  forceFlush() {
    return Promise.resolve();
  }

  shutdown() {
    return Promise.resolve();
  }
}
